import { AuthService } from '../../shared/auth/auth.service';

export type AddMenuDialogInitialMenu = 'AddCandidate' | 'AddDocumentation';

export interface AddMenuDialogData {
  /** Opens the dialog directly on this option, skipping the first menu step. */
  initialMenu?: AddMenuDialogInitialMenu;
}

/** Whether the current user sees this option in the first menu step. */
export function canUseAddMenuOption(menu: AddMenuDialogInitialMenu, authService: AuthService): boolean {
  switch (menu) {
    case 'AddCandidate':
      return authService.isCandidateAdmin() || authService.isCandidateAdminBasic();
    case 'AddDocumentation':
      return authService.isRRHH() || authService.isGestorDocumental();
  }
}
